import { simpleTimezones } from '../../util/simple-timezones';
import { gpCommon } from '../../app';
import timezoneDropdownTemplate from './timezone-dropdown.html';

interface IColorPickerDropdownScope extends ng.IScope {
    selectedTimezone: string | null;
    defaultTimezoneName: string | null;
    dropdownInstance: any; // the instance provided by kendojs

    timezoneDropdownOptions: {
        dataSource: any;
        dataTextField: string;
        dataValueField: string;
    };
}

gpCommon.directive('gpTimezoneDropdown', ['$timeout', function ($timeout: ng.ITimeoutService) {

    function link(scope: IColorPickerDropdownScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
        let $scope = scope;
        let originalLeft: string | null = null;

        let timezoneChoices = simpleTimezones;

        timezoneChoices = [{ id: "", name: $scope.defaultTimezoneName || "" }].concat(timezoneChoices);

        $scope.timezoneDropdownOptions = {
            dataSource: timezoneChoices,
            dataTextField: "name",
            dataValueField: "id",
        };


        $timeout(() => {
            // because of the order that kendo components are initialised, we want to set the kendo dropdown value to 
            // our bound value.  If we don't do this, sometimes the dropdown is provided values AFTER the selected value is set.
            // This means that we wend up with an empty value in the combo box, since it has no values present
            $scope.dropdownInstance.value($scope.selectedTimezone);
        }, 100)
    }

    return {
        restrict: 'E',
        link: link,
        scope: {
            selectedTimezone: '=',
            defaultTimezoneName: '@'
        },
        template: timezoneDropdownTemplate
    };

}]);
